import { FetchPolicy, gql } from '@apollo/client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import client from 'graphql/client';
import { all, call, put, spawn, takeLatest } from 'redux-saga/effects';
import applicationActions from 'redux/application/actions';
import { ReduxAction } from 'types/redux.types';

type SliceState = {
  flags: string[] | null;
};

const initialState: SliceState = {
  flags: null,
};

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {
    fetchFlagsStart: () => {},
    fetchFlagsFinished: (state, action: PayloadAction<string[]>) => {
      state.flags = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', (state) => {
      state = initialState;
    });
  },
});

// saga

const fetchFlagsGraphql = (fetchPolicy: FetchPolicy = 'cache-first') => {
  const query = gql`
    query featureFlags {
      featureFlags
    }
  `;

  return client.query({
    query,
    fetchPolicy,
  });
};

function* fetchFlagsGenerator(action: ReduxAction) {
  const fetchPolicy: FetchPolicy =
    action.type === applicationActions.APPLICATION_HIDE_DONE ? 'network-only' : 'cache-first';
  // @ts-ignore
  const response = yield call(fetchFlagsGraphql, fetchPolicy);
  yield put(actions.fetchFlagsFinished(response.data.featureFlags));
}

export function* fetchFlags() {
  yield takeLatest(
    [actions.fetchFlagsStart.type, applicationActions.APPLICATION_HIDE_DONE],
    fetchFlagsGenerator
  );
}

export function* rootSaga() {
  yield all([spawn(fetchFlags)]);
}

// exports

const { actions, reducer } = featureFlagsSlice;
export const { fetchFlagsStart, fetchFlagsFinished } = actions;
export default reducer;
